export { BackgroundMediaSchema } from "./schemas";
export type { BackgroundMediaBase, BackgroundMediaDynamic } from "./types";
